import { render, staticRenderFns } from "./ShopModelInfo.vue?vue&type=template&id=a52a618c&scoped=true"
import script from "./ShopModelInfo.vue?vue&type=script&lang=js"
export * from "./ShopModelInfo.vue?vue&type=script&lang=js"
import style0 from "./ShopModelInfo.vue?vue&type=style&index=0&id=a52a618c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a52a618c",
  null
  
)

export default component.exports